/* eslint-disable no-param-reassign */
import Vapi from 'vuex-rest-api';

const fetcherAdminSchemas = new Vapi({
  state: {
    fetcherAdminSchemas: {
      forms: {},
    },
  },
})
  .get({
    action: 'getFetcherAdminSchema',
    path: ({
      schema,
    }) => `/api/fetcher/admin/schemas/${schema}`,
    onSuccess: (state, payload, axios, { params }) => {
      state.fetcherAdminSchemas[params.schema] = payload.data;
    },
  })
  .getStore();

export default fetcherAdminSchemas;
